module.exports = __webpack_public_path__ + "img/top_title_parts1.bb4e9309.png";